import React from 'react'
import TermsAndCondition from '../../components/Terms&Condition'

function TermsAndConditionPage() {
  return (
   <TermsAndCondition/>
  )
}

export default TermsAndConditionPage